import React from "react";
import Seo from "../components/Seo";
import Content from "../views/Policy/Content";
import Hero from "../views/Policy/Hero";

const LegalsPage = () => {
  return (
    <React.Fragment>
      <Seo title="Politique de confidentialité" />
      <Hero />
      <Content />
    </React.Fragment>
  );
};

export default LegalsPage;
